const User = ({ ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.63086 9.75217C8.63086 7.89049 10.1385 6.38281 12.0002 6.38281C13.8619 6.38281 15.3696 7.89049 15.3696 9.75217C15.3696 11.6138 13.8619 13.1215 12.0002 13.1215C10.1385 13.1215 8.63086 11.6138 8.63086 9.75217Z"
                stroke="white"
            />
            <path
                d="M4.22021 18.1169C5.38523 16.1871 8.42773 14.8115 11.9999 14.8115C15.572 14.8115 18.6145 16.1871 19.7795 18.1169"
                stroke="white"
            />
            <circle cx="12" cy="12" r="10" stroke="white" />
        </svg>
    )
}

export default User
